<template>
  <div class="bg-white p-3 rounded-3 mb-3">
    <div class="row align-items-center mx-0" style="row-gap: 0.5rem;">
      <div class="col-6 col-md-3">
        <base-input class="mb-0" addon-left-icon="fa fa-calendar">
          <select class="form-control date-field-select" v-model="dateField" @change="onDateFieldChange">
            <option value="">全部</option>
            <option v-for="f in dateFields" :key="f" :value="f">{{ dateFieldLabels[f] }}</option>
          </select>
        </base-input>
      </div>
      <!-- 選了「全部」就不篩日期，日期選擇器也不需要出現 -->
      <div v-if="dateField" class="col-6 col-md-3">
        <AvailableDatePicker
            v-model="dateValue"
            :available-dates="availableDates"
            @change="emitChange"
        />
      </div>
      <div class="col-12" :class="dateField ? 'col-md-6' : 'col-md-9'">
        <base-input
            class="mb-0"
            v-model="keyword"
            placeholder="搜尋 JAN / 品名 / 品牌 / 訂單關鍵字或依結單日快速找貨"
            addon-left-icon="fa fa-search"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AvailableDatePicker from "@/components/AvailableDatePicker.vue";

// 歷史訂單與最新訂單共用的篩選列。
// 日期欄位：'' = 全部（不篩日期）、'publish_date'、'final_date'。
// 可選日期清單由父層傳入 fetchDates(dateField) 取得（兩個頁面各自對應不同的 API）。
// 篩選條件改變時 emit 'change'，payload 為 { dateField, dateValue, keyword }，
// 全部時 dateField／dateValue 都是 undefined。
export default {
  name: "CatalogFilterBar",
  components: {AvailableDatePicker},
  props: {
    fetchDates: {
      type: Function,
      required: true,
    },
    // 可選的日期欄位（過往訂單只需要「依截止日期」）
    dateFields: {
      type: Array,
      default: () => ['publish_date', 'final_date'],
    },
  },
  computed: {
    dateFieldLabels() {
      return {publish_date: '依發布日期', final_date: '依截止日期'};
    },
  },
  data() {
    return {
      keyword: '',
      dateField: '',
      dateValue: '',
      // 目前選的日期欄位底下真的有資料的日期清單，日期選擇器只能選這些日子。
      availableDates: [],
      keywordDebounceTimer: null,
    };
  },
  beforeDestroy() {
    clearTimeout(this.keywordDebounceTimer);
  },
  watch: {
    // 關鍵字輸入即時查詢，用 debounce 避免每個字都送出請求
    keyword() {
      clearTimeout(this.keywordDebounceTimer);
      this.keywordDebounceTimer = setTimeout(() => {
        this.emitChange();
      }, 400);
    },
  },
  methods: {
    // 切換日期欄位時，可選日期清單跟著換，並預設成最近一天（清單由新到舊排序）；
    // 切回「全部」則清掉日期篩選。
    async onDateFieldChange() {
      if (!this.dateField) {
        this.availableDates = [];
        this.dateValue = '';
        this.emitChange();
        return;
      }
      const field = this.dateField;
      const dates = await this.fetchDates(field);
      // 等 API 回來的期間使用者可能又切了別的欄位，過期的結果直接丟掉
      if (field !== this.dateField) return;
      this.availableDates = dates;
      this.dateValue = dates.length > 0 ? dates[0] : '';
      this.emitChange();
    },
    emitChange() {
      this.$emit('change', {
        dateField: this.dateValue ? this.dateField : undefined,
        dateValue: this.dateValue || undefined,
        keyword: this.keyword,
      });
    },
  },
}
</script>

<style scoped>
/* 原生 select 的下拉箭頭是瀏覽器畫的裝飾，不吃 padding，要關掉原生箭頭
   (appearance: none) 換成可以自己控制位置的箭頭圖示才調得動。 */
.date-field-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 1.75rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 5'%3E%3Cpath fill='%23F39800' d='M0 0l4 5 4-5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 10px 6px;
}
</style>
